<template>
    <vs-loader variant="inline" size="12"></vs-loader>
</template>

<script>
import VsLoader from '@vuesimple/vs-loader';

export default {
    name: 'Loader',
    components: {
        VsLoader,
    },
};
</script>